
import { useState } from 'react';
import { IconButton, Avatar } from '@material-ui/core';
import plusIcon from "assets/Images/icons/plusIcon.png";
import { CustomRatings } from "Utills/CustomRatings";
import { Create, Delete, Save } from "@material-ui/icons";
import { check_current_user } from "store/actions";
import axios from "axios";
import { useNotifyContext } from "context/notifyContext"
import { connect } from "react-redux"

// ============= api endpoint
let api_user_img = process.env.REACT_APP_USER_IMAGE


//====================== PROFILE CARD COMPONENT ============================
const ProfileCard = (props) => {
    // this will receive data from props
    let data = props.data;
    // 
    const { set_notify, loading, set_loader } = useNotifyContext();
    // 
    const [userProfileImg, setUserProfileImg] = useState({
        url: "",
        file: "",
        isSelected: false
    });

    //================ select new image from user device ====================
    const selectNewImg = (e) => {
        if (e.target?.files?.length !== 0) {
            const url = URL.createObjectURL(e?.target?.files[0]);
            setUserProfileImg({
                url: url,
                file: e?.target?.files[0],
                isSelected: true
            })
        }

    };

    //====================== remove selected image =========================
    const removeSelectedImg = () => {
        setUserProfileImg({
            url: "",
            file: "",
            isSelected: false
        })
    };

    // =================== change image with API ===================================
    const saveDataImg = () => {
        set_loader(true)
        let storeData = localStorage.getItem("cyan_user");
        let userToken = storeData ? JSON.parse(storeData) : ""
        let url = api_user_img;
        let imageFile = new FormData();
        imageFile.set('image', userProfileImg.file);
        axios.post(url, imageFile, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Token ${userToken}`
            }
        }).then((response) => {
                props.check_current_user(null, () => {
                    setUserProfileImg({
                        url: "",
                        file: "",
                        isSelected: false
                    })
                    set_loader(false)
                    set_notify({ open: true, msg: "Image uploaded successfully", type: "success" })
                });
            }).catch((err) => {
                console.log("Error ====>", err.message);
                set_notify({ open: true, msg: data?.['error-message'], type: "error" })
                set_loader(false)
            })
    };

    //=================== captain =======================
    if (data.mode === true) {
        return (
            <>
                <div className="profile-card">
                    <div className="profile-card-top">
                        <div className="profile-avatar">
                            <Avatar className="big-avatar" src={userProfileImg?.isSelected ? userProfileImg.url : data?.profileImg ? data?.profileImg : '.'} alt={data?.userName?.slice(0, 1)} />
                            {!loading && data.profilePage &&
                                <>
                                    <div className="edit_del_user_img_btn">
                                        <label htmlFor="s" className="bg-pr d-flex justify-content-center align-items-center cursor-pointer rounded-circle">
                                            <Create />
                                            <input className="d-none" onChange={selectNewImg} type="file" name="s" id="s" accept="image/*" />
                                        </label>
                                    </div>

                                </>}
                        </div>
                        {userProfileImg?.isSelected &&
                            <div className="d-flex justify-content-center flex-wrap align-items-center">
                                <button onClick={removeSelectedImg} className="py-1 px-2 mx-1 rounded mt-2 text-white  text-center cursor-pointer d-flex justify-content-center align-items-center bg-danger">
                                    <p>Discard &nbsp; </p>  <Delete />
                                </button>
                                <button onClick={saveDataImg} className="py-1 px-2 mx-1 rounded mt-2 text-white  text-center cursor-pointer d-flex justify-content-center align-items-center bg-pr">
                                    <p>Save &nbsp; </p>  <Save />
                                </button>
                            </div>
                        }
                    </div>
                    <div className="profile-card-body">
                        <h4 className="profile--card-user-name">
                            {data.userName}
                            <span className="text-pr font-weight-bold"> (Captain)</span>
                        </h4>
                        <div className="sub-info">
                            {data.subInfo}
                        </div>
                        <div className="profile-card-reviews text-center mt-2">
                            <h4>

                                <CustomRatings name="read-only" value={5} readOnly /> <span className="text-pr">5</span> <span>(23)</span>
                            </h4>
                        </div>
                        <div className="profile-card-prs-info">
                            {data.viewMode ? <div className=" mt-5  p-xl-4 p-0"></div>
                                : <svg className="arrow-left-in-profile-card mt-5" width="16" height="63" viewBox="0 0 16 63" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.8692 45.2018C15.6856 44.7338 15.3365 44.4421 14.9567 44.4421H9.04333V1.46859C9.04333 0.657928 8.57593 0 8.00004 0C7.42414 0 6.95675 0.657928 6.95675 1.46859V44.4421H1.04337C0.662217 44.4421 0.313062 44.7338 0.130834 45.2018C-0.0541769 45.6698 -0.0416574 46.2416 0.160046 46.6939L7.11672 62.2335C7.30868 62.6604 7.64115 62.9189 8.00004 62.9189C8.35893 62.9189 8.69139 62.6604 8.88336 62.2335L15.84 46.6939C15.9457 46.455 16 46.1828 16 45.9107C16 45.6679 15.9555 45.4231 15.8692 45.2018Z" fill="#1A4D6D" />
                                </svg>
                            }
                            <div className="mt-3">
                                <h4 className="text-pr">Personal Information</h4>
                                <h5>{data?.heading2}  {data.viewMode ? null : <IconButton><img src={plusIcon} alt="" /></IconButton>}</h5>
                                <h5>{data?.heading3}</h5>
                                <h5>{data.heading4}</h5>
                            </div>

                        </div>
                    </div>
                </div>
                {data?.profileCard &&
                    <div className="about-me-card">
                        <h5>About me</h5>
                        <p>
                            The Yacht Captain is responsible for the total operation of the yacht. ... The Yacht Captain is the navigator, and as such is responsible for the safety of the crew and passengers, the supervision of the crew as well as ensuring the enjoyment of all guests onboard.
                        </p>
                        <h5>Avg response rate</h5>
                        <p>1 hour</p>
                        <h5>Joined In</h5>
                        <p>June. 2021</p>
                    </div>}
            </>
        )
    }
    // ================== sailor ================================
    return (
        <div className="profile-card mb-3">
            <div className="profile-card-top">
                <div className="profile-avatar">
                    <Avatar className="big-avatar" src={userProfileImg?.isSelected ? userProfileImg.url : data?.profileImg ? data?.profileImg : '.'} alt={data?.userName?.slice(0, 1)} />
                    {!loading && data.profilePage &&
                        <>
                            <div className="edit_del_user_img_btn">
                                <label htmlFor="s" className="bg-pr d-flex justify-content-center align-items-center cursor-pointer rounded-circle">
                                    <Create />
                                    <input className="d-none" onChange={selectNewImg} type="file" name="s" id="s" accept="image/*" />
                                </label>
                            </div>

                        </>}
                </div>
                {userProfileImg?.isSelected &&
                    <div className="d-flex justify-content-center flex-wrap align-items-center">
                        <button onClick={removeSelectedImg} className="py-1 px-2 mx-1 rounded mt-2 text-white  text-center cursor-pointer d-flex justify-content-center align-items-center bg-danger">
                            <p>Discard &nbsp; </p>  <Delete />
                        </button>
                        <button onClick={saveDataImg} className="py-1 px-2 mx-1 rounded mt-2 text-white  text-center cursor-pointer d-flex justify-content-center align-items-center bg-pr">
                            <p>Save &nbsp; </p>  <Save />
                        </button>
                    </div>
                }
            </div>
            <div className="profile-card-body">
                <h4 className="profile--card-user-name">
                    {data.userName}
                    <span className="text-pr font-weight-bold">(Sailor)</span></h4>
                <div className="sub-info">
                    {data.subInfo}
                </div>
                <div className="profile-card-prs-info">
                    <svg className="arrow-left-in-profile-card" width="16" height="63" viewBox="0 0 16 63" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8692 45.2018C15.6856 44.7338 15.3365 44.4421 14.9567 44.4421H9.04333V1.46859C9.04333 0.657928 8.57593 0 8.00004 0C7.42414 0 6.95675 0.657928 6.95675 1.46859V44.4421H1.04337C0.662217 44.4421 0.313062 44.7338 0.130834 45.2018C-0.0541769 45.6698 -0.0416574 46.2416 0.160046 46.6939L7.11672 62.2335C7.30868 62.6604 7.64115 62.9189 8.00004 62.9189C8.35893 62.9189 8.69139 62.6604 8.88336 62.2335L15.84 46.6939C15.9457 46.455 16 46.1828 16 45.9107C16 45.6679 15.9555 45.4231 15.8692 45.2018Z" fill="#1A4D6D" />
                    </svg>
                    <div className="others">
                        <h4 className="text-pr">Personal Information</h4>
                        <h5>All booking history</h5>
                        <h5 className="text-pr">Favorite List</h5>
                        <h5>{data.heading4}</h5>
                    </div>

                </div>
            </div>
        </div>
    )
}

// Redux configs
const mapDispatchToProps = (dispatch) => ({
    check_current_user: (data, otherFunc) => dispatch(check_current_user(null, otherFunc)),
});

export default connect(null, mapDispatchToProps)(ProfileCard);
